// Hooks
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import useComplianceView from "@hooks/useComplianceView";

// Actions
import LoginAction from "@common/redux/actions/LoginAction";
import AgcCheckAction from "@common/redux/actions/AgcCheckAction";

// Utilities
import { handleError } from "@common/components/helpers/error";
import AgcCheckClient from "@common/api/AgcCheckClient";
import { parseAgcCheckResponse } from "@common/components/helpers/compliance";
import { useSelector } from "react-redux";

function useAgcCheckContainer() {
  const { setViewData } = useComplianceView();
  const {
    activeRow: {
      agcCheck: { id },
    },
  } = useEventDetailsGrid();

  const { questions } = useSelector((state) =>
    AgcCheckAction.getStatePath(state),
  );

  const setState = (data) => AgcCheckAction.dispatch(data);

  const loadRecord = (isRead = true) => {
    if (!id) {
      return;
    }

    setViewData({ formLoading: true });
    const fnRead = isRead ? AgcCheckClient.Read : AgcCheckClient.ReadForUpdate;

    fnRead(id).then(
      (response) => {
        const {
          site: { guid },
        } = response;
        LoginAction.dispatch({ siteGuid: guid, isInReadMode: isRead });
        setState(parseAgcCheckResponse(response, questions));
        setViewData({ formLoading: false });
      },
      (error) => {
        setViewData({ formLoading: false });
        handleError(error);
      },
    );
  };

  return {
    loadRecord,
  };
}

export default useAgcCheckContainer;
